import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import '@lottiefiles/lottie-player';

export default class LottiePlayer {
    constructor(el) {
        document.addEventListener('bless', e => {
            const container = e.target;
            this.init(container);
        });
	}

    init(container) {
		this.container = container;

        const mm = gsap.matchMedia();

		mm.add({
			isMobile: `(max-width: 991px)`,
			isDesktop: `(min-width: 992px)`,
			reduceMotion: '(prefers-reduced-motion: reduce)',
		}, (context) => {
			this.context = context;
            this.container.querySelectorAll('[data-doodle]').forEach((el) => new Doodle(el, this.context));
		});
	}
}

class Doodle {
    constructor(el, context) {
        this.el = el;
        this.lottieInstance = null;
        this.init(context);
    }

    init(context) {
        this.lottieInstance = this.el.getLottie();
        if (this.lottieInstance) {
            ScrollTrigger.create({
                trigger: this.el,
                start: "20px 80%",
                onEnter: () => {
                    if (context.conditions.reduceMotion) {
                        this.goToLastFrame();
                    } else {
                        this.el.play();
                    }
                },
            });
        }
    }

    goToLastFrame() {
        if (this.lottieInstance) {
            const lastFrame = this.lottieInstance.getDuration(true);
            this.lottieInstance.goToAndStop(lastFrame, true);
        }
    }
}
